export default class helper {
  setTabColor(){
    let $ = jQuery;

    //first check loop through all block layout containers and add markup
    $("section[data-wui-tab-top]").each(function(){
      $(this).prepend('<div class="tab-wrapper tab-wrapper-top"></div>');
    });

    $("section[data-wui-tab-bottom]").each(function(){
      $(this).append('<div class="tab-wrapper tab-wrapper-bottom"></div>');
    });

    // Loop bottom tabs to set colors based off of other sections
    $(".tab-wrapper-bottom").each(function(){

      let bg_color = $(this).parent().next().data('bg-color');

      if(bg_color === undefined){
        bg_color = $(this).parents("main").next('[data-bg-color]').data("bg-color");
      }

      $(this).addClass(bg_color);
    });

    // Loop top tabs to set colors based off of other sections
    $(".tab-wrapper-top").each(function(){

      let bg_color = $(this).parent().prev().data('bg-color');
console.log($(this).parent().prev());
      if($(this).parent().prev().find("[data-bg-color]").length > 0){
        bg_color = $(this).parent().prev().find("[data-bg-color]").last().data("bg-color");
      }

      if(bg_color === undefined){
        bg_color = $(this).parents("main").prev('[data-bg-color]').data("bg-color");
      }

      if(bg_color === undefined){
        bg_color = $(this).parents("main").siblings("header").data("bg-color");
      }

      $(this).addClass(bg_color);

      //check to see if there is a tab bottom next to a tab top
      if($(this).parent().prev().is("main") == true){
        if($(this).parent().prev().find("[data-bg-color]").last().data("wui-tab-bottom") != undefined){
          $(this).parent().prev().find("[data-bg-color]").last().removeAttr('data-wui-tab-bottom');
          $(this).parent().prev().find("[data-bg-color]").last().find(".tab-wrapper-bottom").remove();
        }
      } else {
        if ($(this).parent().prev().data("wui-tab-bottom") != undefined) {
          $(this).parent().prev().removeAttr("data-wui-tab-bottom");
          $(this).parent().prev().find(".tab-wrapper-bottom").last().remove();
        }
      }

    });
  }
}

